import { render } from "./LanguagePicker.vue?vue&type=template&id=4ed6340c&scoped=true"
import script from "./LanguagePicker.vue?vue&type=script&lang=js"
export * from "./LanguagePicker.vue?vue&type=script&lang=js"

import "./LanguagePicker.vue?vue&type=style&index=0&id=4ed6340c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed6340c"]])

export default __exports__